import { type SearchFilterAssetCustomFields, type SearchFilterFields } from '@air/api/types';

/** Asset custom-field filters can also match text or a date. These callers only know select-value filters. */
export const isCustomFieldValueFilter = (field: SearchFilterAssetCustomFields): field is SearchFilterFields =>
  !('text' in field.filter) && !('date' in field.filter);
